import { getFullUrl } from 'hubspot-url-utils';
export const allowedOrigins = [getFullUrl('app', {
  domainOverride: 'hubspot',
  envOverride: 'prod'
}), getFullUrl('app', {
  domainOverride: 'hubspot',
  envOverride: 'qa'
}), getFullUrl('app', {
  domainOverride: 'hubteam',
  envOverride: 'qa'
}), getFullUrl('app', {
  domainOverride: 'hubteam',
  envOverride: 'prod'
}), getFullUrl('local', {
  domainOverride: 'hubspot',
  envOverride: 'prod'
}), getFullUrl('local', {
  domainOverride: 'hubspot',
  envOverride: 'qa'
}), getFullUrl('local', {
  domainOverride: 'hubteam',
  envOverride: 'prod'
}), getFullUrl('local', {
  domainOverride: 'hubteam',
  envOverride: 'qa'
})];
export const renderContexts = ['embedded-academy', 'embedded-learnByDoing', 'academy', 'academy-play-on-hover', 'global-nav-recommendations-modal', 'academy-ai-search-query-answer'];